import * as fromEmployees from './employees.actions';
import { initialState, employeesAdapter, EmployeesState } from './employees.interfaces';

export function reducer(state: EmployeesState = initialState, action: fromEmployees.EmployeesAction): EmployeesState {
  switch (action.type) {
    case fromEmployees.GET_EMPLOYEES_FROM_SERVER_SUCCESS: {
      return {
        ...employeesAdapter.addMany(action.payload.employees, state),
      };
      break;
    }

    default: {
      return state;
    }
  }
}
